/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconAxisX = createReactComponent("outline", "axis-x", "IconAxisX", [["path", { "d": "M4 13v.01", "key": "svg-0" }], ["path", { "d": "M4 9v.01", "key": "svg-1" }], ["path", { "d": "M4 5v.01", "key": "svg-2" }], ["path", { "d": "M17 20l3 -3l-3 -3", "key": "svg-3" }], ["path", { "d": "M4 17h16", "key": "svg-4" }]]);

export { IconAxisX as default };
//# sourceMappingURL=IconAxisX.mjs.map
